import { useAppSelector } from "@hooks/useAppSelector";
import { CalculateGrid } from "@redux/uq/uq-actions";
import { UPHeader } from "@redux/uq/uq-slice";
import NumberBoxWrapper from "@/components/NumberBoxWrapper";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { ColumnCellTemplateData } from "devextreme/ui/data_grid";
import { RowEntity, UPRow } from "@/types/types";
import { ValueChangedEvent } from "devextreme/ui/number_box";

type Props = {
  data: ColumnCellTemplateData<UPRow>;
  gridSet?: UPRow[];
};

export default function UpdateComplexCell({ data, gridSet }: Props) {
  const dispatch = useAppDispatch();
  const { indexShift } = useAppSelector((state) => state.uq);
  const col = data.column?.dataField as UPHeader;

  const format = col === "ROR" ? "percent" : "$ #,##0.##";
  const defaultValue = data.value?.value;

  const onValueChanged = (e: ValueChangedEvent) => {
    const values = data.value as RowEntity;
    const newGrid = structuredClone(gridSet);
    const currentIndex = data.rowIndex + indexShift;

    if (newGrid && newGrid[currentIndex] && newGrid[currentIndex][col]) {
      newGrid[currentIndex][col] = {
        value: e.value,
        defaultValue: values.defaultValue,
        note: values.note,
        manualChange: true,
        isExcluded: newGrid[currentIndex]?.[col].isExcluded,
      } as RowEntity;
    }

    dispatch(CalculateGrid(currentIndex, newGrid));
  };

  return (
    <NumberBoxWrapper
      format={format}
      defaultValue={defaultValue}
      className="up-update-cell"
      onValueChanged={onValueChanged}
    />
  );
}
